import axios from "axios";

export const fetchCategories = async (dispatch: any) => {
    axios
        .get((process.env.REACT_APP_API_URL || '') + "/api/v1/categories")
        .then((response) => response.data)
        .then((data: []) => {
            dispatch({
                type: "SET_CATEGORIES",
                categories: data,
            });
        })
        .catch((e) => {
            console.log(e);
        })
};